/*
 * @Author: Liux
 * @Date: 2019-11-19 08:39:37
 * @LastEditor: Liux
 * @LastEditTime: 2020-05-20 16:50:59
 */
export class AdLinkMenuItem {
  /**
   *
   */
  constructor({
    value = null,
    name = null,
    link = '',
    target = '_self',
    action = null,
    selected = false,
    disabled = false,
    routerLink = null,
    cssClass = '',
  } = {}) {
    this.value = value;
    this.name = name;
    this.link = link;
    this.target = target;
    this.action = action;
    this.selected = selected;
    this.disabled = disabled;
    this.routerLink = routerLink;
    this.cssClass = cssClass;
  }

  public value: any; // **required**
  public name: string;
  public link = '';
  public routerLink: any[] = null;
  public isExternal = false;
  public target = '_self'; // just work with the isExternal=true
  public action: any = null; // function
  public selected = false;
  public disabled = false;
  public cssClass = '';
}
